import store from "@/stores/store";
import utils from "@/utils";
import { entityHasBundlesFeature } from "@/utils/features";

export const DEFAULT_GLOBAL_SEARCH_TYPES = [
    "providers",
    "customers",
    "contacts",
    "shipments",
    "receipts",
    "products",
    "providerproducts",
    "customerorders",
    "providerorders",
    "customerinvoices",
    "providerinvoices",
    "stocks",
    "calendar_events",
    "projects",
    "tasks",
];

export const GLOBAL_SEARCH_TYPES = [
    ...DEFAULT_GLOBAL_SEARCH_TYPES,
    "establishments",
    "bundles",
];

const SEARCH_TYPE_PERMISSION_CHECKS = {
    providers: () => utils.userHasPermission("core.view_provider"),
    customers: () => {
        const profile = store.getters["session/current_entity_profile"];
        if (profile === "agent") {
            return utils.userHasPermission("core.view_entity");
        }
        return utils.userHasPermission("core.view_customer");
    },
    contacts: () =>
        utils.userHasPermission("core.view_customer") ||
        utils.userHasPermission("core.view_provider") ||
        utils.userHasPermission("core.view_settings"),
    shipments: () => utils.userHasShipmentPermission("view"),
    receipts: () => utils.userHasReceiptPermission("view"),
    establishments: () => utils.userHasPermission("core.view_establishment"),
    bundles: () =>
        entityHasBundlesFeature(store) &&
        utils.userHasPermission("catalog.view_bundle"),
    products: () => utils.userHasPermission("core.view_product"),
    providerproducts: () => utils.userHasPermission("core.view_product"),
    customerorders: () => utils.userHasCustomerOrderPermission("view"),
    providerorders: () => utils.userHasProviderOrderPermission("view"),
    customerinvoices: () => utils.userHasCustomerInvoicePermission("view"),
    providerinvoices: () => utils.userHasProviderInvoicePermission("view"),
    stocks: () => utils.userHasPermission("stock.view_stock"),
    calendar_events: () => utils.userHasDomainPermission("agenda.view_calendarevent"),
    projects: () => utils.userHasDomainPermission("work.view_workproject"),
    tasks: () => utils.userHasDomainPermission("work.view_worktask"),
};

export function canSearchGlobalType(type) {
    const check = SEARCH_TYPE_PERMISSION_CHECKS[type];
    if (!check) {
        return false;
    }
    return check();
}

export function getAllowedGlobalSearchTypes(types = GLOBAL_SEARCH_TYPES) {
    return types.filter((type) => canSearchGlobalType(type));
}

export function filterGlobalSearchResultTypes(resultTypes) {
    return resultTypes.filter((type) => canSearchGlobalType(type.key));
}
